
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { PqtMeasurementSpecification, PqtMeasurementValueType } from '../../backend/backendapi';
import { camelCase, getEnumValues } from '../../../util';

@Component
export default class PqtMeasurementSpecificationEditor extends Vue {
  @Prop({ required: true })
  readonly specification!: PqtMeasurementSpecification;

  PqtMeasurementValueType = PqtMeasurementValueType; //required to be used in template, vue2 shortcoming
  camelCase = camelCase; //required to be used in template, vue2 shortcoming
  getEnumValues = getEnumValues; //required to be used in template, vue2 shortcoming

  get isFloat(): boolean {
    return this.specification.type === PqtMeasurementValueType.Float;
  }

  get isString(): boolean {
    return this.specification.type === PqtMeasurementValueType.String;
  }

  get specificationRequired(): boolean {
    return !this.specification.optional;
  }

  set specificationRequired(value: boolean) {
    this.specification.optional = !value;
  }

  get uid(): string {
    return this._uid;
  }
}
